export const validEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
export const validateEmail = (email, name, message=null) => {
    if (email === undefined || email === null || !email.trim().match(validEmailRegex)) {
        throw message ? message : `Please provide a valid ${name} address`;
    }
};